import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./layout.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import AttributePage from "../pages/attribute.jsx";
import ProductCategoryPage from "../pages/productcategory.jsx";
import TaxPage from "../pages/TaxConfigPage.jsx";
import CategoryAttributeMap from "../pages/CategoryAttributeMap.jsx";
import Vendor from "../pages/Vendor.jsx";
import Products from "../pages/Products.jsx";
import ProductAttributePage from "../pages/Productattribute.jsx";
import InventorySummry from "../pages/Inventorysummry.jsx";
import InventoryTransaction from "../pages/Inventorytransaction.jsx";
import InventoryItem from "../pages/Inventoryitem.jsx";
import BarcodeScanPopup from "../components/BarcodeScanPopup.jsx";
import Catalouge from "../pages/Catalouge.jsx";





/* ════════════════════════════════════════
   NAV CONFIG  — add new pages here
════════════════════════════════════════ */
const NAV = [
  {
    label: "Main",
    items: [
      { icon: "bi-grid", label: "Dashboard" },
      { icon: "bi-box-seam", label: "Products" },
      { icon: "bi-truck", label: "Vendor" },
      { icon: "bi-box-arrow-in-down", label: "Bulk Stock In" },
      { icon: "bi-arrow-left-right", label: "Inventory Transaction" },
      { icon: "bi-stack", label: "Stocks" },
    ],
  },
  {
    label: "Manage",
    items: [
      { icon: "bi-sliders", label: "Attributes" },
      { icon: "bi-diagram-2", label: "Product Attributes" },
      { icon: "bi-layers", label: "Product Category" },
      { icon: "bi-receipt-cutoff", label: "Tax Configuration" },
      { icon: "bi-diagram-3", label: "Category Attribute Map" },
    ],
  },
  {
    label: "Settings",
    items: [
      { icon: "bi-gear", label: "Catalouge" },
      { icon: "bi-gear", label: "Settings" },
      { icon: "bi-bell", label: "Notifications" },
    ],
  },
];

/* ════════════════════════════════════════
   PAGE ROUTER  — add new pages here
════════════════════════════════════════ */
function PageContent({ active }) {
  switch (active) {
    case "Dashboard": return <DefaultContent />;
    case "Attributes": return <AttributePage />;
    case "Product Category": return <ProductCategoryPage />;
    case "Tax Configuration": return <TaxPage />;
    case "Category Attribute Map": return <CategoryAttributeMap />;
    case "Vendor": return <Vendor />;
    case "Products": return <Products />;
    case "Product Attributes": return <ProductAttributePage />;
    case "Bulk Stock In": return <InventorySummry />;
    case "Inventory Transaction": return <InventoryTransaction />;
    case "Stocks": return <InventoryItem />;



    case "Collections": return <ComingSoon page="Collections" />;
    // case "Products": return <ComingSoon page="Products" />;
    case "Analytics": return <ComingSoon page="Analytics" />;
    case "Catalouge": return <Catalouge />;


    case "Settings": return <ComingSoon page="Settings" />;
    case "Notifications": return <ComingSoon page="Notifications" />;

    default: return <DefaultContent />;
  }
}

/* ════════════════════════════════════════
   LAYOUT
════════════════════════════════════════ */
export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(
    localStorage.getItem("activePage") || "Dashboard"
  );
  const navigate = useNavigate();

  const storedUser = JSON.parse(localStorage.getItem("user"));

  console.log("USER DATA:", storedUser);

  const userName =
    storedUser?.firstName && storedUser?.lastName
      ? `${storedUser.firstName} ${storedUser.lastName}`
      : storedUser?.firstName ||
      storedUser?.lastName ||
      storedUser?.name ||
      storedUser?.fullName ||
      storedUser?.userName ||
      storedUser?.username ||
      storedUser?.email ||
      "User";

  const firstLetter = userName.charAt(0).toUpperCase();

  const handleNav = (label) => {
    setActiveItem(label);
    setSidebarOpen(false);
    localStorage.setItem("activePage", label);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("activePage");
    navigate("/");
  };

  return (
    <div className="rv-layout">

      {/* ══ SIDEBAR ══ */}
      <aside className={`rv-sidebar ${sidebarOpen ? "rv-sidebar--open" : ""}`}>

        {/* Logo */}
        <div className="rv-logo">
          <div className="rv-logo-mark">
            <span className="rv-logo-dot" />
            <span className="rv-logo-dot rv-logo-dot--sm" />
          </div>
          <span className="rv-logo-text">REVAA</span>
        </div>

        {/* Nav */}
        <nav className="rv-nav">
          {NAV.map(group => (
            <div className="rv-nav-group" key={group.label}>
              <p className="rv-nav-label">{group.label}</p>
              {group.items.map(item => (
                <button
                  key={item.label}
                  className={`rv-nav-item ${activeItem === item.label ? "rv-nav-item--active" : ""}`}
                  onClick={() => handleNav(item.label)}
                >
                  <span className="rv-nav-icon">
                    <i className={`bi ${item.icon}`} />
                  </span>
                  <span className="rv-nav-text">{item.label}</span>
                  {activeItem === item.label && <span className="rv-nav-pip" />}
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* User card */}
        <div className="rv-user">
          <div className="rv-avatar">{firstLetter}</div>

          <div className="rv-user-info">
            <p className="rv-user-name">{userName}</p>
            <p className="rv-user-role">Store Admin</p>
          </div>
          <button className="rv-logout" title="Logout" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right" />
          </button>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="rv-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ══ MAIN ══ */}
      <div className="rv-main">

        {/* HEADER */}
        <header className="rv-header">
          <div className="rv-header-left">
            <button
              className="rv-hamburger d-lg-none"
              onClick={() => setSidebarOpen(v => !v)}
            >
              <span /><span /><span />
            </button>
            <div>
              <h1 className="rv-page-title">{activeItem}</h1>
            </div>
          </div>

          <div className="rv-header-right">
            <div className="rv-search d-none d-md-flex">
              <i className="bi bi-search" />
              <input placeholder="Search…" />
            </div>
            <button className="rv-icon-btn">
              <i className="bi bi-bell" />
              <span className="rv-badge">3</span>
            </button>
            <div className="rv-header-avatar">
              {firstLetter}
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <main className="rv-content">
          <PageContent active={activeItem} />
        </main>

      </div>
    </div>
  );
}

/* ════════════════════════════════════════
   COMING SOON stub
════════════════════════════════════════ */
function ComingSoon({ page }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      height: "60vh", gap: "12px", textAlign: "center",
    }}>
      <div style={{
        width: 60, height: 60, borderRadius: "50%",
        background: "rgba(185,167,146,.14)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--taupe)", fontSize: 26,
      }}>
        <i className="bi bi-clock" />
      </div>
      <p style={{ fontFamily: "var(--d-font)", fontSize: 14, color: "var(--dark)" }}>
        {page}
      </p>
      <p style={{ fontSize: 12.5, color: "var(--taupe)" }}>
        This page is coming soon.
      </p>
    </div>
  );
}

/* ════════════════════════════════════════
   DEFAULT DASHBOARD CONTENT
════════════════════════════════════════ */
function DefaultContent() {
  const stats = [
    { label: "Total Revenue", value: "₹2,48,500", delta: "+12.4%", up: true },
    { label: "Orders Today", value: "38", delta: "+5", up: true },
    { label: "New Customers", value: "124", delta: "-2.1%", up: false },
    { label: "Pending Shipments", value: "17", delta: "On time", up: true },
  ];

  return (
    <div className="container-fluid p-0">
      <div className="row g-3 mb-4">
        {stats.map(s => (
          <div className="col-6 col-xl-3" key={s.label}>
            <div className="rv-card rv-stat">
              <p className="rv-stat-label">{s.label}</p>
              <p className="rv-stat-value">{s.value}</p>
              <span className={`rv-stat-delta ${s.up ? "rv-stat-delta--up" : "rv-stat-delta--dn"}`}>
                {s.delta}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-3">
        <div className="col-12 col-lg-8">
          <div className="rv-card">
            <div className="rv-card-head">
              <h2 className="rv-card-title">Recent Orders</h2>
              <button className="rv-link">View all</button>
            </div>
            <div className="rv-table-wrap">
              <table className="rv-table">
                <thead>
                  <tr>
                    <th>Order</th>
                    <th>Customer</th>
                    <th className="d-none d-sm-table-cell">Item</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { id: "#4821", cust: "Meera Shah", item: "Diamond Set", amt: "₹18,500", status: "Delivered" },
                    { id: "#4820", cust: "Riya Patel", item: "Pearl Earrings", amt: "₹4,200", status: "Processing" },
                    { id: "#4819", cust: "Anjali Mehta", item: "Gold Bangle", amt: "₹9,800", status: "Shipped" },
                    { id: "#4818", cust: "Nisha Desai", item: "Kundan Necklace", amt: "₹22,000", status: "Pending" },
                    { id: "#4817", cust: "Priya Joshi", item: "Silver Ring", amt: "₹2,400", status: "Delivered" },
                  ].map(o => (
                    <tr key={o.id}>
                      <td className="rv-order-id">{o.id}</td>
                      <td>{o.cust}</td>
                      <td className="d-none d-sm-table-cell">{o.item}</td>
                      <td>{o.amt}</td>
                      <td>
                        <span className={`rv-status rv-status--${o.status.toLowerCase()}`}>
                          {o.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4">
          <div className="rv-card h-100">
            <div className="rv-card-head">
              <h2 className="rv-card-title">Top Collections</h2>
              <button className="rv-link">See all</button>
            </div>
            <div className="rv-collections">
              {[
                { name: "Diamond Bridal Set", sold: 142, pct: 87 },
                { name: "Kundan Jewellery", sold: 98, pct: 60 },
                { name: "Pearl Collection", sold: 76, pct: 46 },
                { name: "Gold Temple Set", sold: 54, pct: 33 },
              ].map(c => (
                <div className="rv-coll-item" key={c.name}>
                  <div className="rv-coll-info">
                    <span className="rv-coll-name">{c.name}</span>
                    <span className="rv-coll-sold">{c.sold} sold</span>
                  </div>
                  <div className="rv-progress-track">
                    <div className="rv-progress-fill" style={{ width: `${c.pct}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}